import { forwardRef } from "react";
import { cn } from "../../lib/cn.js";
import { badgeVariants } from "../../lib/variants.js";

const Badge = forwardRef(
  (
    {
      className,
      variant = "default",
      size = "md",
      children,
      ...props
    },
    ref
  ) => {
    const baseClasses = "inline-flex items-center justify-center rounded-full font-semibold";
    const variantClasses = badgeVariants.variant[variant] || badgeVariants.variant.default;
    const sizeClasses = badgeVariants.size[size] || badgeVariants.size.md;
    
    return (
      <span
        ref={ref}
        className={cn(
          baseClasses,
          variantClasses,
          sizeClasses,
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";

export default Badge;